import { BaseEntity } from '../../../Api/Types/baseTypes';

export enum OfferOptionUsageType {
  Info = 0,
  Mandatory = 1,
  Additional = 2,
}

export interface OfferOptionTypeValue {
  id: number;
  value?: string;
  shortName?: string;
}

export interface OfferOptionType {
  id: number;
  name: string;
  offerOptionsValues: OfferOptionTypeValue[];
}

export interface OfferOption {
  offerOptionsTypeId: number;
  offerOptionsValueId: number;
}

export interface OfferOptionsMapping extends BaseEntity {
  offerOptionMappingId: number;
  offerId: number;
  offerOptionsTypeId: number;
  offerOptionsTypeName?: string;
  offerOptionsValueId: number;
  offerOptionsValueName?: string;
  usageType: OfferOptionUsageType;
  amount?: number | null;
  percentage?: number | null;
  currency?: string | null;
}
